module.exports = __webpack_public_path__ + "static/media/adm.ac7dc75f.svg";